var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="row">\n  <div class="col-sm-12">\n    <div class="icon-addon addon-md">\n      <input type="text" placeholder="Search fields" name="substitution-param-search" class="form-control">\n      <label for="substitution-param-search"><i data-icon="search"></i></label>\n    </div>\n  </div>\n</div>\n';
}
return __p;
};
